'use strict';

(function () {
  /**
   *
   * @type {{build: build, secondsFromNow: secondsFromNow, set: set, get: get, unset: unset, _getExpiry: _getExpiry, _getDomain: _getDomain}}
   */
  var Cookie = {
    /**
     *
     * @returns {String}
     */
    build: function build() {
      var parts = Array.prototype.slice.apply(arguments);
      for (var i = 0; i < parts.length; i++) {
        if (!parts[i]) parts.splice(i, 1);
      }
      return parts.join("; ");
    },
    /**
     *
     * @param   {String} seconds
     * @returns {String}
     */
    secondsFromNow: function secondsFromNow(seconds) {
      var d = new Date();
      d.setTime(d.getTime() + seconds * 1000);
      return d.toGMTString();
    },

    // This weird encoding/decoding of cookie values is due to the way
    // Rack::Utils#escape handles cookie serialization. In order to
    // stay consistent with how rack will serialize cookies, we
    // are performing it on the client side.
    //
    /**
     *
     * @param {String} name
     * @param {String} value
     * @param {String} seconds
     * @param {String} domain
     */
    set: function set(name, value, seconds, domain) {
      var cookieExpiry = this._getExpiry(seconds),
          cookieDomain = this._getDomain(domain);

      if (typeof value === "string") {
        value = value.replace(/\s/g, '+');
      }
      document.cookie = Cookie.build(name + "=" + encodeURIComponent(value), cookieExpiry, "path=/", cookieDomain);
    },
    /**
     *
     * @param   {String}      name
     * @returns {String|null}
     */
    get: function get(name) {
      var valueMatch = new RegExp("(?:^|;(?:\\s*))" + name + "=([^;]+)").exec(document.cookie);
      var value = valueMatch ? valueMatch[1] : null;
      try {
        return value !== null ? decodeURIComponent(value).replace(/\+/g, ' ') : null;
      } catch (e) {
        return null;
      }
    },
    /**
     *
     * @param {String} name
     * @param {String} domain
     */
    unset: function unset(name, domain) {
      Cookie.set(name, '', -1, domain);
    },
    /**
     *
     * @param   {String}      seconds
     * @returns {String|null}
     * @private
     */
    _getExpiry: function _getExpiry(seconds) {
      return seconds ? 'expires=' + Cookie.secondsFromNow(seconds) : null;
    },
    /**
     *
     * @param   {String} domain
     * @returns {*}
     * @private
     */
    _getDomain: function _getDomain(domain) {
      return domain ? 'domain=' + domain : null;
    }
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Cookie;
  }

  window.Cookie = Cookie;
})();